import { FC } from 'react'

import { NatureElement } from '../types'
import { LeafElementImage } from './leaf-element-image'

export const LeafElement: FC<NatureElement> = ({ size = 335, onClick, className }) => {
  return (
    <svg
      x="-25"
      y="-5"
      height={size}
      width={size}
      viewBox="0 0 71 70"
      fill="none"
      onClick={onClick}
      className={className}
    >
      <g filter="url(#filter0_dd_54_922)">
        <rect
          width="61.399"
          height="62"
          transform="matrix(-1 0 0 1 66.3496 0)"
          fill="url(#leaf-element)"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_54_922"
          x="0.950684"
          y="0"
          width="69.3989"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_922" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_54_922" result="effect2_dropShadow_54_922" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_922" result="shape" />
        </filter>
        <pattern id="leaf-element" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use href="#image0_54_922" transform="matrix(0.000753012 0 0 0.000745712 -0.00564759 0)" />
        </pattern>
        <LeafElementImage />
      </defs>
    </svg>
  )
}
